import { render } from "./Deploy.vue?vue&type=template&id=06c2cd9d"
import script from "./Deploy.vue?vue&type=script&lang=ts"
export * from "./Deploy.vue?vue&type=script&lang=ts"
script.render = render

export default script